<p [innerHtml]="bodyContent | safeHtml"></p>
